import React from 'react'; // eslint-disable-line
import { useInfiniteHits, UseInfiniteHitsProps } from 'react-instantsearch';

/** @jsxImportSource @emotion/react */

export default function CachedSearch(props: UseInfiniteHitsProps & { pageBump: number; setResults: (results: { hits: any[]; hasMore: boolean }) => void }) {
  const {pageBump: currentPage, setResults, ...useInfiniteHitsProps} = props;
  const { items, isLastPage, showMore } = useInfiniteHits(useInfiniteHitsProps);
  const [pageBump, setPageBump] = React.useState(props.pageBump);
  React.useEffect(() => {
    if (pageBump !== currentPage) {
      setPageBump(currentPage);
      showMore();
    }
  }, [props.pageBump, pageBump, showMore]);

  React.useEffect(() => {
    setResults({ hits: items, hasMore: !isLastPage });
  }, [items, isLastPage, setResults]);
  return <></>;
}
